import React from 'react';
import {
  CarType,
  CourierJson,
  CourierRatingJson,
  CourierRetentionJson,
  TravelMode,
} from 'types/bundleTypes';

import '../AddCourierModal/AddCourierModal.scss';
import { MdClose } from 'react-icons/md';
import { COLOR } from '../../../const/color';
import { ReqEnum } from '../../../const/requestStatus';
import { RatingConst, TimesBookedConst } from '../../../const/ShiftConst';

export function emojiBasedOnAvgRating(avgRating: number): string {
  if (avgRating <= RatingConst.avgRating1.value) {
    return RatingConst.avgRating1.emoji;
  } else if (avgRating <= RatingConst.avgRating2.value) {
    return RatingConst.avgRating2.emoji;
  } else if (avgRating <= RatingConst.avgRating3.value) {
    return RatingConst.avgRating3.emoji;
  } else if (avgRating <= RatingConst.avgRating4.value) {
    return RatingConst.avgRating4.emoji;
  } else if (avgRating <= RatingConst.avgRating5.value) {
    return RatingConst.avgRating5.emoji;
  } else if (avgRating <= RatingConst.avgRating6.value) {
    return RatingConst.avgRating6.emoji;
  } else if (avgRating <= RatingConst.avgRating7.value) {
    return RatingConst.avgRating7.emoji;
  }
}

function emojiBasedOnRatingMethod(
  couriersRating: CourierRatingJson[],
  courier: CourierJson
): string {
  const indexToUse = couriersRating
    .map(obj => obj.courierId)
    .indexOf(courier.id.toString());

  if (indexToUse > -1) {
    const avgRating = couriersRating[indexToUse].averageRating;
    return emojiBasedOnAvgRating(avgRating);
  }
  return '';
}

function emojiBasedOnRetentionMethod(
  couriersRetention: CourierRetentionJson[],
  courier: CourierJson
) {
  const indexToUse = couriersRetention
    .map(obj => obj.courierId)
    .indexOf(courier.id);

  if (indexToUse > -1) {
    const numberOfTimesBooked =
      couriersRetention[indexToUse].numberOfTimesBooked;

    if (numberOfTimesBooked <= TimesBookedConst.nrOfTimesBooked1.value) {
      return TimesBookedConst.nrOfTimesBooked1.emoji;
    } else if (
      numberOfTimesBooked <= TimesBookedConst.nrOfTimesBookedUnder.value
    ) {
      return TimesBookedConst.nrOfTimesBookedUnder.emoji;
    } else if (
      numberOfTimesBooked > TimesBookedConst.nrOfTimesBookedOver.value
    ) {
      return TimesBookedConst.nrOfTimesBookedOver.emoji;
    }
    return TimesBookedConst.nrOfTimesBookedElse.emoji;
  } else {
    return TimesBookedConst.nrOfTimesBookedElse.emoji;
  }
}

function symbolBasedOnTravelMode(
  travelMode: TravelMode,
  carType?: CarType
): string {
  if (travelMode === TravelMode.BIKE) {
    return '🚵‍♂️';
  } else {
    if (carType === CarType.ELECTRIC) {
      return '🔌';
    } else if (carType === CarType.CARGO_BIKE) {
      return '🦄';
    } else {
      return '🚗';
    }
  }
}

export function CourierBox({
  selectedCourierList,
  courier,
  couriersRating,
  fetchCouriersRatingStatus,
  couriersRetention,
  fetchCouriersRetentionStatus,
  setSelectedCourierList,
  setSearch,
  typeOfBox,
}: {
  selectedCourierList: CourierJson[];
  courier: CourierJson;
  couriersRating: CourierRatingJson[];
  fetchCouriersRatingStatus: ReqEnum;
  couriersRetention: CourierRetentionJson[];
  fetchCouriersRetentionStatus: ReqEnum;
  setSelectedCourierList: (selectedCourierList: CourierJson[]) => void;
  setSearch: (search: string) => void;
  typeOfBox?: string;
}): JSX.Element {
  const removeSelectedFromList = (removeThisId: number) => {
    const newList = selectedCourierList.filter(
      courier => courier.id !== removeThisId
    );
    setSelectedCourierList(newList);
  };

  const IsSelected: boolean =
    selectedCourierList &&
    selectedCourierList.length > 0 &&
    selectedCourierList
      .map((selectedCourier: CourierJson) => selectedCourier.id)
      .indexOf(courier.id) !== -1;

  const emojiBasedOnRating: string =
    fetchCouriersRatingStatus === ReqEnum.SUCCESS
      ? emojiBasedOnRatingMethod(couriersRating, courier)
      : '';

  const heatEmojiBasedOnRetention: string =
    fetchCouriersRetentionStatus === ReqEnum.SUCCESS
      ? emojiBasedOnRetentionMethod(couriersRetention, courier)
      : TimesBookedConst.nrOfTimesBookedElse.emoji;

  return (
    <button
      className="courierNameButton"
      style={{
        backgroundColor: IsSelected && COLOR.SHIFT_GREEN,
        color: IsSelected && COLOR.WHITE,
      }}
    >
      <div
        className="nameButton"
        onClick={() => {
          if (selectedCourierList) {
            const isAllreadyInList = selectedCourierList.includes(courier);
            if (!isAllreadyInList) {
              setSelectedCourierList([...selectedCourierList, courier]);
              setSearch(null);
            }
          } else {
            setSelectedCourierList([courier]);
            setSearch(null);
          }
        }}
      >
        {` ${
          typeOfBox === 'WISH'
            ? symbolBasedOnTravelMode(courier.travelMode, courier.carType)
            : ''
        } ${emojiBasedOnRating} ${courier.firstName} ${
          courier.lastName
        } ${heatEmojiBasedOnRetention}`}
      </div>
      <div className="displayEtaOffsett">{`eta ${courier.etaOffsetSeconds}`}</div>
      {IsSelected && (
        <div
          className="exit-sign-in-button"
          onClick={() => {
            removeSelectedFromList(courier.id);
            setSearch(null);
          }}
        >
          <MdClose />
        </div>
      )}
    </button>
  );
}
